<template>
  <div class="hello">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <div>
          <span>{{ $store.state.project.projectName }}</span>
        </div>
      </div>
      <div class="box">
        <div class="left-box">
          <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="rDate"
              placeholder="选择日期"
              ref="datePick"
              @change="chooseDate"
              type="date"
              :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="continer-right">
          <div class="right-box">
            <div v-for="(item,index) in ruleList"
                 :class="[{ 'itemsActive': active === index },{ 'itemsDabale': item.status === 1 },{ 'itemsFalie': item.status === 2 }]"
                 class="items itemColor"
                 @click="activeItem(item,index)">
              <p>{{ item.date }}</p>
              <p v-if="item.status ===0">总共:{{item.totalNum}}  剩余:{{ item.leftNum }} </p>
              <p v-else>{{ item.status === 1 ? '不可预约' : '已约满' }}</p>
              <p>已预约人数：{{item.totalNum - item.leftNum}}</p>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {getPriorProjectInfo, getPriorRuleInfo, getPriorProjectListByItemCode} from "@/api/project"
import wasm from "@/mixins/wasm"
import {checkReservationQueue} from "@/api/log/log";

export default {
  name: 'HelloWorld',
  mixins: [wasm],
  data() {
    return {
      rDate: '',
      ruleList: [],
      dateList: [],
      active: '',
    }
  },
  async mounted() {
    await this.initwasm().then(() => {
      let itemCode = this.$route.query.itemCode
      if (itemCode) {
        this.getPriorProjectListByItemCode(itemCode)
      } else {
        this.getPriorProjectInfo()
      }
    })
  },
  computed: {
    pickerOptions() {
      let that = this
      return {
        disabledDate(time) {
          return that.dateList.indexOf(that.formatDate(time)) === -1
        }
      }
    }
  },
  methods: {
    getPriorProjectListByItemCode(itemCode) {
      let data = {
        itemCode: itemCode
      }
      getPriorProjectListByItemCode(1,1, data).then(res => {
        console.log(res);
        const total = res.data.records
        if (total >= 1) {
          const item = res.data.rows[0]
          this.$store.commit("setProject", item.projectInfo)
          this.getPriorProjectInfo()
        }
      })
    },
    getPriorProjectInfo() {
      let data = {
        projectId: this.$store.state.project.projectId,
        busiType: '1'
      }
      getPriorProjectInfo(data).then(res => {
        this.dateList = res.data.info.dateList
        this.$refs.datePick.focus()
      })
      checkReservationQueue(data).then(res => {
        console.log("======================");
        console.log(res);
      })
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    },
    chooseDate() {
      this.active = ''
      this.$store.commit("reSetRule")
      this.$refs.datePick.focus(); // 选择日期后依旧触发焦点
      this.ruleList = []
      let data = {
        projectId: this.$store.state.project.projectId,
        rDate: this.rDate
      }
      getPriorRuleInfo(data).then(res => {
        this.ruleList = res.data.info.ruleList
        this.ruleList.forEach(item => {
          item.date = item.timeRange
          item.num = item.leftNum
          if (item.leftNum === 0) {
            item.status = 1
          } else {
            item.status = 0
          }
        })
      })
    },
    activeItem(item, index) {
      if (item.status === 0) {
        this.active = index
        this.$store.commit('setRule', this.ruleList[index])
      }
    }
  }
}
</script>

<style lang="less" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;


  span {
    margin: 0 10px;
  }

  span:nth-child(1) {
    font-weight: 500;
  }

  span:nth-child(3) {
    color: #427AF4;
  }
}

.box {
  display: flex;
  justify-content: space-between;
  height: 300px;
  overflow: auto;
  ::v-deep .left-box {
    width: 30%;

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }
  }

  .continer-right {
    width: 65%;
    height: 295px;
    border: 1px solid #f5f5f5;
    overflow: auto;
    display: grid;
    .right-box {

      display: grid;
      padding: 20px;

      grid-template-columns: repeat(3, 32%);
      row-gap: 20px;
      justify-content: space-between;

      .items {
        padding: 10px;
        cursor: pointer;

        p {
          text-align: center;
          margin: 5px;
        }
      }

      .itemColor {
        background: #F6F8FA;
      }

      .itemsActive {
        border: 1px solid #B6D8FF;
        background: #ECF5FF;
        color: #1480FF;
      }

      .itemsDabale {
        background: #F5F5F5;
        color: #999999;
        cursor: not-allowed;
        border: none
      }

      .itemsFalie {
        background: #FFF3F0;
        color: #ED5B56;
        cursor: not-allowed;
        border: 1px solid #FFF3F0;
      }

    }
  }


}

::v-deep .pages {
  margin: 20px 0;

  .el-pagination {
    display: flex;
  }

  .el-pagination__sizes {
    margin-left: auto;
  }
}
</style>
